import { render, staticRenderFns } from "./CorrelationWeightSetup.vue?vue&type=template&id=6e562122&"
import script from "./CorrelationWeightSetup.vue?vue&type=script&lang=js&"
export * from "./CorrelationWeightSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports